// client/components/forms/shared/SelectStyles.js
// Zentrale react-select Styles — Dark-only
import { Z_INDEX } from "../../ui/zIndex.js";

/** @param {boolean} [_isDark] Legacy-Parameter (ignoriert) */
export const getRsStyles = (_isDark) => ({
  control: (base, state) => ({
    ...base,
    background: "#0b1324",
    borderColor: state.isFocused ? "rgba(96,165,250,.5)" : "rgba(255,255,255,.1)",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(96,165,250,.2)" : "none",
    minHeight: "44px",
    ":hover": {
      borderColor: state.isFocused ? "rgba(96,165,250,.6)" : "rgba(255,255,255,.15)",
    },
  }),
  valueContainer: (b) => ({ ...b, paddingBlock: 8 }),
  singleValue: (b) => ({ ...b, color: "#dbeafe" }),
  input: (b) => ({ ...b, color: "#dbeafe" }),
  placeholder: (b) => ({
    ...b,
    color: "rgba(219,234,254,.5)",
  }),
  menu: (b) => ({
    ...b,
    background: "#0b1324",
    color: "#dbeafe",
    border: "1px solid rgba(255,255,255,.12)",
    backdropFilter: "blur(12px)",
    boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
    borderRadius: 12,
    overflow: "hidden",
    zIndex: Z_INDEX.selectPortal,
  }),
  menuList: (b) => ({
    ...b,
    maxHeight: "min(55dvh, 360px)",
    paddingTop: 4,
    paddingBottom: 4,
  }),
  option: (b, s) => ({
    ...b,
    background: s.isFocused ? "#0f1b33" : "#0b1324",
    color: "#dbeafe",
    cursor: "pointer",
    minHeight: "44px",
    display: "flex",
    alignItems: "center",
    padding: "10px 14px",
    fontSize: "0.875rem",
    lineHeight: "1.35",
    whiteSpace: "normal",
    wordBreak: "break-word",
  }),
  menuPortal: (b) => ({ ...b, zIndex: Z_INDEX.selectPortal }),
  multiValue: (b) => ({
    ...b,
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 10,
  }),
  multiValueLabel: (b) => ({
    ...b,
    color: "#dbeafe",
    paddingRight: 6,
  }),
  multiValueRemove: (b) => ({
    ...b,
    color: "#dbeafeCC",
    borderRadius: 8,
    ":hover": {
      background: "rgba(255,255,255,0.10)",
      color: "#fff",
    },
  }),
});
